import {trackPromotionInteraction} from '@aboutyou/legacy-tracking-sdk';
import {Promotion} from '../trackerComponents/TrackPromotions';
import {getPromotionData} from '../utils/promotionDataGetter';
import {useTracking} from '../utils/utils';

interface TrackPromotionInterface {
  promotion: Promotion;
  streamPosition: number;
  actionType: 'click' | 'impression';
}

export const useTrackPromotion = () => {
  const {pageContextCallback, TrackingClient} = useTracking();

  return ({promotion, streamPosition, actionType}: TrackPromotionInterface) => {
    const promotionData = getPromotionData({
      promotion,
      streamPosition,
      pageType: pageContextCallback().type,
    });

    const promotionInteractionData = trackPromotionInteraction({
      ...promotionData,
      type: actionType,
    });

    TrackingClient.track(promotionInteractionData);
  };
};
